"use client";

import React, { createContext, useContext } from "react";
import type { ComposeRecipientsContextValue } from "@/lib/core/crm/types";

const ComposeRecipientsContext = createContext<ComposeRecipientsContextValue | null>(null);

interface ComposeRecipientsProviderProps {
  children: React.ReactNode;
  value: ComposeRecipientsContextValue;
}

export function ComposeRecipientsProvider({
  children,
  value,
}: ComposeRecipientsProviderProps) {
  return (
    <ComposeRecipientsContext.Provider value={value}>
      {children}
    </ComposeRecipientsContext.Provider>
  );
}

export function useComposeRecipientsContext() {
  const context = useContext(ComposeRecipientsContext);
  if (!context) {
    throw new Error("useComposeRecipientsContext must be used within a ComposeRecipientsProvider");
  }
  return context;
}
